import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalitatiComponent } from './localitati.component';
import { AddLocalitatiComponent } from './add-localitati/add-localitati.component';
import { EditLocalitatiComponent } from './edit-localitati/edit-localitati.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        LocalitatiComponent,
        AddLocalitatiComponent,
        EditLocalitatiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [LocalitatiComponent]
})
export class LocalitatiModule { }
